import React, { Component, Fragment } from 'react';
import './ReviewApplicants.css';
import { hostIsBgoResidents } from 'helpers/CurrentWindowLocation';

class ApplicantQuestions extends Component {
  render() {
    const applicationQuestions = {
      marginTop: '7px',
      marginBottom: '7px',
      color: '#212121',
      textAlign: 'justify',
    };

    const applicationQuestionAnswers = {
      color: '#6F6F6F',
      textAlign: 'right',
      verticalAlign: 'middle',
      margin: '0',
    };

    const style = {
      question_width: {
        width: '75%',
      },
      question_padding: {
        padding: '0 15px',
      },
      full_width: {
        width: '100%',
      },
      question_container: {
        padding: '0 0',
        marginTop: '15px',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    if (!this.props.applicant_data) return null;

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Application Questions</h5>
        </div>

        <div className="row" style={style.question_container}>
          {!hostIsBgoResidents() && (
            <Fragment>
              <div className="row" style={style.question_padding}>
                <table style={style.full_width}>
                  <tbody>
                    <tr>
                      <td style={style.question_width}>
                        <h5 style={applicationQuestions}>
                          Have you ever been evicted from a tenancy or left owing money?
                        </h5>
                      </td>
                      <td>
                        <p style={applicationQuestionAnswers}>
                          {' '}
                          {this.props.applicant_data.eviction}{' '}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row" style={style.question_padding}>
                <table style={style.full_width}>
                  <tbody>
                    <tr>
                      <td style={style.question_width}>
                        <h5 style={applicationQuestions}>
                          Have you ever been part of a landlord or tenant hearing?
                        </h5>
                      </td>
                      <td>
                        <p style={applicationQuestionAnswers}>
                          {' '}
                          {this.props.applicant_data.court}{' '}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row" style={style.question_padding}>
                <table style={style.full_width}>
                  <tbody>
                    <tr>
                      <td style={style.question_width}>
                        <h5 style={applicationQuestions}>
                          Have you ever been convicted of a crime or felony?
                        </h5>
                      </td>
                      <td>
                        <p style={applicationQuestionAnswers}>
                          {' '}
                          {this.props.applicant_data.felony}{' '}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="row" style={style.question_padding}>
                <table style={style.full_width}>
                  <tbody>
                    <tr>
                      <td style={style.question_width}>
                        <h5 style={applicationQuestions}>
                          Have you ever declared personal bankruptcy?
                        </h5>
                      </td>
                      <td>
                        <p style={applicationQuestionAnswers}>
                          {' '}
                          {this.props.applicant_data.bankruptcy}{' '}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Fragment>
          )}

          <div className="row" style={style.question_padding}>
            <table style={style.full_width}>
              <tbody>
                <tr>
                  <td style={style.question_width}>
                    <h5 style={applicationQuestions}>Have you lived with us before?</h5>
                  </td>
                  <td>
                    <p style={applicationQuestionAnswers}>
                      {' '}
                      {this.props.has_previously_rented ? 'Yes' : 'No'}{' '}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="row" style={style.question_padding}>
            <table style={style.full_width}>
              <tbody>
                <tr>
                  <td style={style.question_width}>
                    <h5 style={applicationQuestions}>Why are you moving?</h5>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p>{this.props.applicant_data.reason_for_moving}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default ApplicantQuestions;
